import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  payment = 'PricingYunoPayment',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/yuno/payment/',
    component: () => import('@/modules/yuno/layout/LayoutPage.vue'),
    children: [
      {
        path: '',
        name: MODULE_ROUTE.payment,
        component: () => import('@/modules/yuno/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
